import React, { useState, useEffect } from 'react';
import styles from './Header.module.css';

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 100);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        setIsMobileMenuOpen(false);
    };

    return (
        <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}>
            <div className="container">
                <div className={styles.headerContent}>
                    <div className={styles.logo}>
                        <a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>
                            <i className="fa fa-briefcase"></i> CHEKi74
                        </a>
                        <div className={styles.phone}>
                            <a href="tel:+79874817932">+7 (987) 481-79-32</a>
                        </div>
                    </div>



                    <nav className={`${styles.nav} ${isMobileMenuOpen ? styles.navOpen : ''}`}>
                        <a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>Главная</a>
                        <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>О нас</a>
                        <a href="#order" onClick={(e) => { e.preventDefault(); scrollToSection('order'); }}>Online Заказ</a>
                        <a href="#advantages" onClick={(e) => { e.preventDefault(); scrollToSection('advantages'); }}>Преимущества</a>
                        <a href="#reviews" onClick={(e) => { e.preventDefault(); scrollToSection('reviews'); }}>Отзывы</a>
                        <a href="#examples" onClick={(e) => { e.preventDefault(); scrollToSection('examples'); }}>Примеры чеков</a>
                        <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Контакты</a>
                    </nav>

                    <button
                        className={styles.mobileToggle}
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;